module.exports = __webpack_public_path__ + "static/media/roi-header.93ed709a.jpg";